import React, { Component } from 'react';
import BuoyOverview from './BuoyOverview';
// import './App.css';

class Home extends Component {
  render() {
    return (
      <div>
        {/* <p className="App-intro">
          Actuele meetgegevens van Noordzee meetpunten op volgorde Noord &rarr; Zuid
        </p> */}
        <BuoyOverview />
        {/* <p className="disclaimer">
          Meetgegevens afkomstig van <a href="https://waterinfo.rws.nl/">Waterinfo</a>
        </p> */}
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/Components/Home.jsx